import React from 'react';

import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import s from './collapse.scss';

type PropsType = {
    duration?: number;
    isOpen: boolean;
    children: React.ReactNode;
};

/**
 * Collapse component
 *
 * @constructor
 */
export const Collapse: React.FC<PropsType> = ({children, duration = 500, isOpen}) => (
    <AnimateHeight
        aria-hidden={!isOpen}
        aria-label="Collapsible content"
        duration={duration}
        height={isOpen ? 'auto' : 0}
    >
        <div
            className={classNames(s.content, {
                [s.notTransparent]: isOpen,
                [s.visible]: isOpen,
            })}
        >
            {children}
        </div>
    </AnimateHeight>
);
